<template>
  <DeepZoomSample :detail="detail"></DeepZoomSample>
</template>

<script>
import 'photoswipe/style.css';
import DeepZoomSample from "@/views/DeepZoomSample";

export default {
  name: 'HomeView',
  props: {
    detail: String,
  },
  components: {
    DeepZoomSample
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  methods:{

  }
}
</script>
